
import apiClient from '../utils/apiClient'

const loginUser = async (userData) => {
  try {
    const response = await apiClient().post("user/login/", userData);
    return response.data;
  } catch (err) {
    // You could do something with the error here, like logging or even re-throwing
    console.log(err);
    throw err;
  }
};

export const createWaitlistEntry = async (formData) => {
  try {
    const response = await apiClient().post("user/create-entry/", formData);
    return response.data;
  } catch (err) {
    // You could do something with the error here, like logging or even re-throwing
    console.log(err);
    throw err;
  }
};

const sendOtp = async (data) => {
    return apiClient().post('user/send-otp/', data, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    })
}

const checkStatus = async () => {
    return apiClient().get("user/status-check");
}

export { loginUser, sendOtp, checkStatus };